import { HttpInterceptorFn } from '@angular/common/http';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  // Requisições ao CyberArk / Portal Minha Área não devem receber o JWT
  // interno — o IdP recebe a request limpa.
  if (req.url.includes('cyberark.cloud') || req.url.includes('minhaarea.sp.gov.br')) {
    return next(req);
  }

  const token = localStorage.getItem('token');
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq);
};